import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import getThemeClasses from '@oxygen/theme';
import styles from './Column.module.scss';
var propTypes = process.env.NODE_ENV !== "production" ? {
  /** Html tag or react component to render */
  as: PropTypes.elementType,

  /** Child node */
  children: PropTypes.node.isRequired,

  /** Classes to customize column */
  className: PropTypes.string,

  /** No. of columns an element should span to out of 12 */
  span: PropTypes.number
} : {};
var defaultProps = {
  className: '',
  as: 'div',
  span: 12
};
var commonColumnClasses = "".concat("o-fpkJwH o-dCyDMp o-cglRxs", " ").concat(styles.column);

var getColumnClasses = classes => "".concat(classes, " ").concat(commonColumnClasses);

var COLUMN = {
  1: getColumnClasses("o-dSjKll o-eIjyDg"),
  2: getColumnClasses("o-dTGbGQ o-dfrAFj"),
  3: getColumnClasses("o-cAYjuL o-IXuUu"),
  4: getColumnClasses("o-benkjq o-frfCNH"),
  5: getColumnClasses("o-dQEruD o-ckbllM"),
  6: getColumnClasses("o-mYtNI o-brTzeV"),
  7: getColumnClasses("o-fhPSld o-fgiuEy"),
  8: getColumnClasses("o-dpDliG o-eAyrtt"),
  9: getColumnClasses("o-dfaWMx o-MjvTQ"),
  10: getColumnClasses("o-ezORAX o-ZFJlA"),
  11: getColumnClasses("o-bEhiOO o-eTQIgH"),
  12: getColumnClasses("o-ybCXb o-cxkOxW")
};

function Column(props) {
  var {
    as: Tag,
    className,
    span,
    children
  } = props,
      otherProps = _objectWithoutProperties(props, ["as", "className", "span", "children"]);

  return React.createElement(Tag, _extends({
    className: "".concat(COLUMN[span], " ").concat(className)
  }, otherProps), children);
}

Column.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
Column.defaultProps = defaultProps;
export default Column;